import React, { useState } from 'react';

function Contact() {
  const [formData, setFormData] = useState({
    'first-name': '',
    'last-name': '',
    'date-of-birth': '',
    'email': '',
    'reason': 'appointment',
    'message': ''
  });
  const [showPopup, setShowPopup] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError(null);
    
    try {
      // Get the Worker URL from environment variable or use default for development
      const workerUrl = process.env.REACT_APP_WORKER_URL || '/api/contact';
      
      // Transform form data for the worker
      const requestData = {
        firstName: formData['first-name'],
        lastName: formData['last-name'],
        dateOfBirth: formData['date-of-birth'],
        email: formData.email,
        reason: formData.reason,
        message: formData.message
      };
      
      // Send data to Cloudflare Worker
      const response = await fetch(workerUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });
      
      const result = await response.json();
      
      if (!response.ok || !result.success) {
        throw new Error(result.error || 'Failed to send email');
      }
      
      // Success - show popup and reset form
      setShowPopup(true);
      setFormData({
        'first-name': '',
        'last-name': '',
        'date-of-birth': '',
        'email': '',
        'reason': 'appointment',
        'message': ''
      });
      
    } catch (err) {
      console.error('Contact form error:', err);
      setError(err.message || 'Failed to send. Please try again.');
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <div className="contact-form">
          <h2>Request an appointment</h2>
          <form onSubmit={handleSubmit}>
            <label htmlFor="first-name">First Name:</label>
            <input
              type="text"
              id="first-name"
              name="first-name"
              value={formData['first-name']}
              onChange={handleInputChange}
              autoComplete="given-name"
              required
            />
            <label htmlFor="last-name">Last Name:</label>
            <input
              type="text"
              id="last-name"
              name="last-name"
              value={formData['last-name']}
              onChange={handleInputChange}
              autoComplete="family-name"
              required
            />
            <label htmlFor="date-of-birth">Date of Birth:</label>
            <input
              type="date"
              id="date-of-birth"
              name="date-of-birth"
              value={formData['date-of-birth']}
              onChange={handleInputChange}
              autoComplete="bday"
              required
            />
            <label htmlFor="email">Email Address:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              autoComplete="email"
              inputMode="email"
              required
            />
            <label htmlFor="reason">Reason:</label>
            <select
              id="reason"
              name="reason"
              value={formData.reason}
              onChange={handleInputChange}
              required
            >
              <option value="appointment">I want to schedule an appointment</option>
              <option value="question">I have a question</option>
              <option value="consultation">I want a consultation</option>
            </select>
            <label htmlFor="message">Message:</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleInputChange}
              required
            ></textarea>
            <input type="submit" value={sending ? 'Sending...' : 'Submit'} disabled={sending} />
            {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}
          </form>
          {showPopup && (
            <div className="popup-overlay" onClick={() => setShowPopup(false)}>
              <div className="popup-box">
                <p>Your message has been sent! Thank you.</p>
                <button onClick={() => setShowPopup(false)}>Close</button>
              </div>
            </div>
          )}
        </div>
        <div className="contact-image">
          <img
            src={process.env.PUBLIC_URL + '/assets/images/steff.gif'}
            alt="Contact"
          />
        </div>
      </div>
    </section>
  );
}

export default Contact; 